import GlobirdSelectorOption from 'data/GlobirdSelectorOption';

const menuOptions: GlobirdSelectorOption<string>[] = [
    {name: 'Link Management', value: 'linkmanagement'},
    {name: 'Referral History', value: 'referralhistory'},
];

export default menuOptions;